import { ExistingMembership } from "../../models/membership";
import LoadingSpinner from "../LoadingSpinner";
import MembershipPill from "../Memberships/MembershipPill";

export default function MembershipExistsForLineItem(props: {
  membership: ExistingMembership | null;
  templateTitle: string;
  fetching: boolean;
  errorFetching: boolean;
}): JSX.Element {
  return (
    <div
      className={`relative min-w-48 max-w-fit rounded-md border border-blue-800 bg-blue-50 px-3 pb-2 pt-5 text-blue-900`}
    >
      <p className="absolute -top-3 left-2 rounded-full border border-blue-800 bg-blue-200 px-2.5 py-0.5 text-sm font-medium text-gray-900">
        Membership Created
      </p>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        {props.fetching && (
          <span className="ml-4 flex items-center gap-x-2">
            <LoadingSpinner marginClass="" colorClass="text-blue-900" />
            <p>Fetching...</p>
          </span>
        )}
        {props.errorFetching && <p className="ml-4">Error fetching</p>}
        {props.membership && (
          <MembershipPill
            membership={props.membership}
            title={props.templateTitle}
          />
        )}
      </div>
    </div>
  );
}
